<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th>LM SKU</th>
        <th>Client SKU</th>
        <th>UPC</th>
        <th>Qty</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="component in product.components" :key="component.id">
        <td style="width: 200px;">{{ component.component_id }}</td>
        <td style="width: 200px;">{{ component.sku }}</td>
        <td style="width: 200px;">{{ component.upc }}</td>
        <td style="width: 200px;">{{ component.qty }}</td>
        <td>{{ component.name }}</td>
      </tr>
      <tr v-if="!product.components || product.components.length == 0">
        <td colspan="5" class="text-center p-4">
          This SKU is not a kit.
        </td>
      </tr>                  
    </tbody>              
  </table>   
</template>
<script>



export default {
  name: 'component-tab',
  props: ['product']
}
</script>
